import React, { useState, useEffect, useRef } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
//import { sendDataToWebService} from './services/SendImageService';
import './css/getvideo.css';
import axios from 'axios';
import Cookies from 'js-cookie';

function formatMilliseconds(milliseconds) {
  const totalSeconds = Math.floor(milliseconds / 1000);
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const paddedSeconds = seconds < 10 ? `0${seconds}` : seconds;
  return `${minutes}:${paddedSeconds}`;
}

function GetVideo() {
  const location = useLocation();
  // console.log(location.state);
  const data = location.state.items || []; // Accessing data passed from Screen 1
  // console.log(data);
  const navigate = useNavigate();
  const [progress, setProgress] = useState(0);
  const [timeRemaining, setTimeRemaining] = useState(null);
  const [timecompleted, settimeCompleted] = useState(false);
  const [loading, setLoading] = useState(false);
  const forreadyvideoRef = useRef('');

  const [text, settext] = useState([]);



  useEffect(() => {
    const totalDuration = 180000;
    let elapsedTime = 0;
    const interval = setInterval(() => {
      elapsedTime += 1000;
      const calculatedProgress = (elapsedTime / totalDuration) * 100;
      setProgress(calculatedProgress);

      const calculatedTimeRemaining1 = (totalDuration - elapsedTime);
      const calculatedTimeRemaining = formatMilliseconds(calculatedTimeRemaining1);
 
      setTimeRemaining(calculatedTimeRemaining);

      if (elapsedTime >= totalDuration) {

        console.log('Checking video ready state:', forreadyvideoRef.current);
        if (forreadyvideoRef.current === '') {
          console.log("Video not ready yet, extending time...");
          elapsedTime = 20000;
          setLoading(true);
        }
        else {
          clearInterval(interval);
          settimeCompleted(true);
          setProgress(100);
          console.log("Video is ready:", forreadyvideoRef.current);
          navigate('/ready', { state: { forreadyvideo: forreadyvideoRef.current } });
        }
      }
    }, 1000);

    const scriptout = Cookies.get('scripttxt');
    console.log('cookie in getvideo', scriptout);
    
    const Scripted = { text: scriptout };
    
    // REDUNDANCY FIX: Ensure script is passed in multiple likely expected formats
    // and ensure captionData exists and enables captions.
    let enhancedCaptionData = data.captionData || { caption_switch: true, caption_color: '#000000' };
    enhancedCaptionData = { 
        ...enhancedCaptionData, 
        text: scriptout,       // Pass script inside captionData
        script: scriptout,     // Pass as 'script' key too
        caption_switch: true   // Force enable captions to solve "script not showing"
    };
    
    // Update data with enhanced caption object
    const updatedData = { 
        ...data, 
        Scripted, 
        captionData: enhancedCaptionData 
    };

    console.log('Sending updatedData to API:', updatedData);

    axios.post('https://generateaivideo.stellans.com/api/receiveimages.php', { data: updatedData })
      .then((response) => {
        console.log("API Response received:", response.data);
        if (response.data) {
          forreadyvideoRef.current = response.data;
        } else {
             console.warn("API returned empty data");
        }
        
        if (timecompleted) {
          console.log('Response received after timeout completed');
        }
      })
      .catch((error) => {
        console.error("Error during the POST request", error);
      });

    return () => clearInterval(interval);
  }, []);


  /*
  
    useEffect(() => {
      const interval = setInterval(() => {
        setProgress((prevProgress) => {
          if (prevProgress >= 100) {
            clearInterval(interval);
            setCompleted(true);
            return 100;
          }
          return prevProgress + 10; // Increment progress
        });
    
        setTimeRemaining((prevTime) => {
          if (prevTime <= 1) {
            return 0;
          }
          return prevTime - 1; // Decrement time remaining
        });
      }, 1000); // Update every second
    
      return () => clearInterval(interval); // Cleanup on component unmount
    }, []);
  
    */

  {/*
useEffect(() => {
    const timer = setTimeout(() => {
      navigate('/ready');  // Path to navigate to after the delay
    }, 10000);  // Delay in milliseconds

    // Cleanup function to clear the timer if the component unmounts before the timeout
    return () => clearTimeout(timer);
  }, [navigate]);  // Dependency array includes `navigate` to ensure stability
*/}
  const localvalue = localStorage.getItem('loglevel');
  //data[]=Array('localval')
  // const combineara = [...data, localvalue]
  //sendDataToWebService (combineara);
  return (
    <>

      {/*<div>
            <div>Progress: {progress.toFixed(2)}%</div>
            <div style={{ width: '100%', backgroundColor: '#ddd', margin: '10px 0' }}>
            <div style={{ width: `${progress}%`, backgroundColor: 'green', height: '20px' }}></div>
            </div>
            {timeRemaining !== null && <div>Estimated Time Remaining: {timeRemaining.toFixed(2)} seconds</div>}
            {timecompleted && <div>Request Completed!</div>}
        </div>*/}

      <div className="short-creator-block">
        <div className='videospecific'>

          <h3 class="mb-6 text-center">AI short is almost ready...</h3>

          <img class="mx-auto mb-6" src={`${process.env.PUBLIC_URL}/images/video-gradient.svg`} alt="video" />

          <div class="flex items-center w-full mb-4">
            <div class="progress-bar mr-4">
              <div class="progress" style={{ width: `${progress}%` }}></div>
            </div>
            <h4>{progress.toFixed(0)}%</h4>
          </div>

          {loading ? <div className="waitlong">Validating....</div> : ''}

          <div class="flex items-center justify-center mb-6">
            <span class="text-gray mr-1">Estimated time:</span>
            {timeRemaining !== null && <span class="text-black font-semibold">{timeRemaining}</span>}
          </div>

          <div class="short-limit-info">
            <span class="material-icons">info</span>
            Please do not close tab before generate AI short
          </div>

        </div>
      </div>
    </>
  );
}

export default GetVideo;
